import ImagePreview from './image-preview'

export default {
    install: function(Vue) {
        Vue.component('ImagePreview', ImagePreview)
    }
}